/** Where an authenticated visitor lands: the ecosystem home, not a product.
 *  Frame 02 exists precisely so the organization switcher comes before any
 *  product decision.
 *
 *  It lives in its own module because both the router and the Shell need it,
 *  and importing it from the router would make the two depend on each other. */
export const HOME_PATH = "/inicio";
